// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".block[data-v-851b9822]{background-color:var(--el-color-white);padding:20px;border-radius:10px}", ""]);
// Exports
module.exports = exports;
